import React from 'react'

export default function ModalAddUser_NoUsersFound() {
    return (
        <div className="flex-column-center-center h-100-percent">
            <div className="isvg-search-empty w-130 min-h-76"/>
            <div className="ui5-txt-no-accent-small p-t-20">No users found</div>
        </div>
    )
}
